import cashPooling from './cashPooling';
import transferMoney from './transferMoney';
import withdrawCash from './withdrawCash';

export default [transferMoney, withdrawCash, cashPooling];
